// tslint:disable
/**
 * Ux
 * insightux admin api
 *
 * The version of the OpenAPI document: 0.62
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { useMutation, useRequest } from "redux-query-react";
import { createSelector } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import { isEqual } from "lodash";
import * as runtime from '../runtime';
import { objectToHash } from "common/object-helper";
import { PmiFromJSON, PmiPricesFromJSON, PmiPricesToJSON, } from '../models';
/**
 * Delete a custom PMI by id
 * Individual Public Market Index
 */
export function deletePmiByIdRaw(requestParameters, requestConfig = {}) {
    if (requestParameters.id === null || requestParameters.id === undefined) {
        throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling deletePmiById.');
    }
    let queryParameters = null;
    let queryString = "";
    const headerParameters = {};
    const { meta = {} } = requestConfig;
    meta.authType = ['bearer'];
    const config = {
        url: runtime.BASE_PATH + `/pmis/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))) + queryString,
        meta,
        update: requestConfig.update || {
            Pmis: (prevValue, transformedValue) => {
                const updateValue = { ...prevValue };
                delete updateValue[requestParameters.id];
                return updateValue;
            }
        },
        optimisticUpdate: requestConfig.optimisticUpdate || {
            Pmis: (prevValue) => {
                const optimisticValue = { ...prevValue };
                delete optimisticValue[requestParameters.id];
                return optimisticValue;
            }
        },
        rollback: requestConfig.rollback || {
            Pmis: (initialValue, currentValue) => {
                const rollbackValue = { ...currentValue };
                rollbackValue[requestParameters.id] = initialValue[requestParameters.id];
                return rollbackValue;
            }
        },
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'DELETE',
            headers: headerParameters,
        },
        body: queryParameters,
    };
    config.queryKey = requestConfig.queryKey || `DeletePmiById-${objectToHash(requestParameters)}`;
    return config;
}
/**
* Delete a custom PMI by id
* Individual Public Market Index
*/
/**
 * Mutation hook for deleting a Pmis, with optimistic update and optimized rollback in case of failure.
 * @param customQueryConfig TypedQueryConfig options set here will override default options.
 * @returns [QueryState, RunMutation] queryState and an async call to delete a Pmis
 */
export const useDeletePmiById = (customQueryConfig) => {
    return useMutation((id, customQueryParam) => deletePmiById({ id }, { ...customQueryConfig, meta: { ...customQueryConfig?.meta, ...customQueryParam } }));
};
export function deletePmiById(requestParameters, requestConfig) {
    return deletePmiByIdRaw(requestParameters, requestConfig);
}
/**
 * Endpoint for fetching all generic market indices
 * Get generic market indices
 */
export function getGenericPmisRaw(requestConfig = {}) {
    let queryParameters = null;
    let queryString = "";
    const headerParameters = {};
    const { meta = {} } = requestConfig;
    const config = {
        url: runtime.BASE_PATH + `/genericPmis` + queryString,
        meta,
        update: requestConfig.update || {
            Pmis: (prevValue, transformedValue) => {
                return { ...prevValue, ...transformedValue };
            }
        },
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'GET',
            headers: headerParameters,
        },
        body: queryParameters,
        transform: requestConfig.transform ? requestConfig.transform : (body, text) => {
            const objResponse = body.map(PmiFromJSON);
            return {
                Pmis: objResponse.reduce((map, obj) => {
                    map[obj.id] = obj;
                    return map;
                }, {})
            };
        }
    };
    config.queryKey = requestConfig.queryKey || `GetGenericPmis`;
    return config;
}
/**
* Endpoint for fetching all generic market indices
* Get generic market indices
*/
export function getGenericPmis(requestConfig) {
    return getGenericPmisRaw(requestConfig);
}
/**
 * Get the list of public market indices (pmi)
 * List Public Market Indices
 */
export function getPmisRaw(requestConfig = {}) {
    let queryParameters = null;
    let queryString = "";
    const headerParameters = {};
    const { meta = {} } = requestConfig;
    const config = {
        url: runtime.BASE_PATH + `/pmis` + queryString,
        meta,
        update: requestConfig.update || {
            Pmis: (prevValue, transformedValue) => {
                return { ...prevValue, ...transformedValue };
            }
        },
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'GET',
            headers: headerParameters,
        },
        body: queryParameters,
        transform: requestConfig.transform ? requestConfig.transform : (body, text) => {
            const objResponse = body.map(PmiFromJSON);
            return {
                Pmis: objResponse.reduce((map, obj) => {
                    map[obj.id] = obj;
                    return map;
                }, {})
            };
        }
    };
    config.queryKey = requestConfig.queryKey || `GetPmis`;
    return config;
}
/**
* Get the list of public market indices (pmi)
* List Public Market Indices
*/
/**
 * Use this selectors to get a record of all Array<Pmi>, with their ids as keys
 * @returns A record of Array<Pmi> object, with their ids as keys
 */
export const usePmisRecordSelector = () => useSelector((state) => state.entities.Pmis, isEqual);
const PmisArraySelector = createSelector((state) => state.entities.Pmis, (selectedSubState) => Object.keys(selectedSubState).map((id) => selectedSubState[id]));
/**
 * Use this selector to get a reference to a flat Array<Pmi>.
 * If you are doing transformation on this object, consider using usePmisRecordSelector instead for performances
 * @returns An array containing all loaded Pmis
 */
export const usePmisArraySelector = () => useSelector(PmisArraySelector, isEqual);
/**
 * Request hook for Array<Pmi>
 * @param customQueryConfig TypedQueryConfig options set here will override default options.
 * @returns an array containg the data, query status, and a call for refresh
 * (note : refresh shouldn't be necessary, update to the state should be handle by mutators)
 */
export const useGetPmis = (customQueryConfig) => {
    const [querystate, forceRefresh] = useRequest(getPmisRaw(customQueryConfig));
    return [
        usePmisArraySelector(),
        querystate,
        forceRefresh
    ];
};
export function getPmis(requestConfig) {
    return getPmisRaw(requestConfig);
}
/**
 * Import custom public market indices
 * Import custom PMIs
 */
export function importCustomPmisRaw(requestParameters, requestConfig = {}) {
    let queryParameters = null;
    let queryString = "";
    const headerParameters = {};
    headerParameters['Content-Type'] = 'application/json';
    const { meta = {} } = requestConfig;
    meta.authType = ['bearer'];
    const config = {
        url: runtime.BASE_PATH + `/pmis` + queryString,
        meta,
        update: requestConfig.update || {
            Pmis: (prevValue, transformedValue) => {
                return { ...prevValue, ...transformedValue };
            }
        },
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'PUT',
            headers: headerParameters,
        },
        body: requestParameters.pmiPrices?.map(PmiPricesToJSON),
        transform: requestConfig.transform ? requestConfig.transform : (body, text) => {
            const objResponse = body.map(PmiPricesFromJSON);
            return {
                Pmis: objResponse.reduce((map, obj) => {
                    map[obj.id] = obj;
                    return map;
                }, {})
            };
        }
    };
    config.queryKey = requestConfig.queryKey || `ImportCustomPmis-${objectToHash(requestParameters)}`;
    return config;
}
/**
* Import custom public market indices
* Import custom PMIs
*/
/**
 * Mutation hook to upsert an Array<PmiPrices>
 * @param customQueryConfig TypedQueryConfig options set here will override default options.
 * @returns [QueryState, RunMutation] queryState and an async call to upsert an Array<PmiPrices>
 */
export const useImportCustomPmis = (customQueryConfig) => {
    return useMutation((pmiPrices, customQueryParam) => importCustomPmisRaw({ pmiPrices }, { ...customQueryConfig, meta: { ...customQueryConfig?.meta, ...customQueryParam } }));
};
export function importCustomPmis(requestParameters, requestConfig) {
    return importCustomPmisRaw(requestParameters, requestConfig);
}
